<template>
  <div>
    <!-- <div class="row mb-2" v-for="(vj, key) in inputs.files" :key="key"> -->
    <!-- <form
      action="
    "
    > -->
    <app-note
        class="mb-primary"
        title="Nota"
        content-type="html"
        :notes="[
          'Se permite un máximo de 15 archivos.',
          'Cada archivo puede tener un máximo de 8MB.',
        ]"
      />
    <div class="row mb-2" v-for="(vj, j) in files" :key="j">
      <div class="col-12 col-md-5">
        <app-input
          :id="`filename_${j}`"
          type="text"
          v-model="vj.filename"
          placeholder="Descripcion del archivo"
          @keyup="onKeyUp(j)"
        />
      </div>

      <div class="col-12 col-md-5" v-if="!vj.annexed">
        <app-input
          :id="`file_${j}`"
          type="file"
          :label="vj.file ? vj.file.name : $t('upload_your_file')"
          v-model="vj.file"
          @change="onChange($event, j)"
        />
        <small v-if="!vj.annexed" class="text-center text-danger"><b>Tamaño máximo del archivo 8 MB</b></small>
      </div>

      <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
        <button
          type="submit"
          class="btn btn-warning"
          @click="removeRowFile(j)"
          v-if="!vj.annexed"
        >
          Quitar
        </button>
      </div>

      <div class="col-12 col-md-6 text-center" v-if="vj.annexed">
        <button
          type="submit"
          class="btn btn-success"
          @click.prevent="openTab(vj.annexed)"
        >
          <app-icon name="file" /> Ver
        </button>

        <button
          type="submit"
          class="btn btn-danger"
          @click.prevent="openDeleteModal(j, vj)"
        >
          <app-icon name="trash-2" /> Eliminar
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <button type="submit" class="btn btn-primary" @click="addFile()">
          <app-icon name="plus" /> Agregar archivo
        </button>
      </div>
    </div>
    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
    <!-- </form> -->
  </div>
</template>
<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../../apiUrl";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    inputs: Object,
  },
  data() {
    return {
      preloader: false,
      deleteModal: false,
      files: [],
      tmp: {},
      delayTimer: null,
    };
  },
  created() {
    this.dataInfo();
  },
  methods: {
    dataInfo() {
      this.files = this.inputs.eval_annexes_files;
    },
    addFile() {
      if (this.files.length >= 15) {
        this.$toastr.e(
          "Solo se pueden adjuntar un maximo de 15 archivos"
        );
        return;
      }
      this.files.push({
        record_id: this.inputs.id,
        filename: null,
        file: null,
      });
    },

    openTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    confirmed() {
      const url = `${actions.TREASURY_PROFORMA}/destroy?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          const tmp = this.files.filter(
            (value, index) => index != this.tmp.j
          );
          this.files = tmp;
        })
        .catch(({ error }) => {});
    },

    removeRowFile(j) {
      this.files = this.files.filter((value, index) => index != j);
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChange(e, j) {
      const tmp = this.files[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.files[j], "file", null);
        this.$set(this.files[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }

      if (!tmp.filename)
        this.$set(this.files[j], "filename", e.target.files[0].name);

      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.files[j];
      if (!tmp.filename || tmp.filename.length == 0) return;
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `${actions.TREASURY_PROFORMA}/addFile`;
      let formData = new FormData();
      // formData.append('id', this.inputs.id)
      for (const [key, value] of Object.entries(this.files[j])) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          const data = res.data.data[res.data.data.length - 1];
          const tmp = [...this.files];
          tmp[j] = data;
          this.files = tmp;
        })
        .catch(({ error }) => {});
    },
  },
};
</script>
